module.exports = __webpack_public_path__ + "media/social-youtube-fcdb46b2.svg";